module.exports = __webpack_public_path__ + "9a23d1d6cdfc6de37525b3cef283e388.svg";